// External Link Constants
import {
  QuestionaireUrl,
  THRONE_URL,
  CASH_APP_URL,
  APPLE_PAY_EMAIL,
  VENMO_URL,
  WISHLIST_URL,
  ONLYFANS_URL,
  TWITTER_BUSINESS_URL,
  INSTAGRAM_PAGE_URL,
  SNAPCHAT_URL,
  LOYALFANS_URL,
  TIKTOK_URL,
  YOUPAY_URL,
  SCATBOOK_URL,FANSLY_URL,FETLIFE_URL,
  TELEGRAM_URL,
} from '../../utils/Constants';
// Icons
import {
    FaTwitter,
    FaInstagram,
    FaSnapchat,
    FaAmazon,
    FaApple,
    FaTiktok,
    FaTelegramPlane,
  } from 'react-icons/fa';
  import { BsQuestionCircle } from 'react-icons/bs';
  import { SiVenmo, SiCashapp, SiOnlyfans } from 'react-icons/si';
  import { GiStoneThrone } from 'react-icons/gi';
  import { MdPayments } from 'react-icons/md';
  import { RiScales3Fill } from 'react-icons/ri';
  import { FaFan } from "react-icons/fa6";
  import { FaNimblr } from "react-icons/fa6";
  import { SiFandango } from "react-icons/si";

export const linkButtonArray = [
  {
    text: 'Submit Application',
    link: QuestionaireUrl,
    icon: <BsQuestionCircle />,
  },
  { text: 'Throne Wishlist', link: THRONE_URL, icon: <GiStoneThrone /> },
  { text: 'LoyalFans', link: LOYALFANS_URL, icon: <FaNimblr /> },
  { text: 'OnlyFans', link: ONLYFANS_URL, icon: <SiOnlyfans /> },
  { text: 'Fansly', link: FANSLY_URL, icon: <FaFan /> },
  { text: 'Twitter', link: TWITTER_BUSINESS_URL, icon: <FaTwitter /> },
  { text: 'Fetlife', link: FETLIFE_URL, icon: <SiFandango /> },
  { text: 'Cash App', link: CASH_APP_URL, icon: <SiCashapp /> },
  { text: 'Apple Pay', link: APPLE_PAY_EMAIL, icon: <FaApple /> },
  { text: 'Venmo', link: VENMO_URL, icon: <SiVenmo /> },
  { text: 'Amazon Wishlist', link: WISHLIST_URL, icon: <FaAmazon /> },
  { text: 'Instagram', link: INSTAGRAM_PAGE_URL, icon: <FaInstagram /> },
  { text: 'Snapchat', link: SNAPCHAT_URL, icon: <FaSnapchat /> },
  { text: 'TikTok', link: TIKTOK_URL, icon: <FaTiktok /> },
  { text: 'YouPay', link: YOUPAY_URL, icon: <MdPayments /> },
  { text: 'Scatbook', link: SCATBOOK_URL, icon: <RiScales3Fill /> },
  { text: 'Telegram', link: TELEGRAM_URL, icon: <FaTelegramPlane /> },
];